<template>
    <div>
        <p class="label">{{ label }}</p>
        <MultiplePickerInput :value="value" @input="onInput" :items="items" v-bind="$attrs" />
    </div>
</template>

<script>
  import MultiplePickerInput from '@/components/inputs/MultiplePickerInput.vue';
  import StudyLevelService from '@/services/study-level.service.js';

  export default {
    name: "StudyLevelMultiplePickerInput",
    components: {
      MultiplePickerInput,
    },
    props: {
      value: Array,
      label: { type: String, default: 'Niveau'}
    },
    data() {
      return {
        items: [],
      }
    },
    created() {
      this.loadListItem();
    },
    methods: {
      loadListItem() {
        const _this = this;

        StudyLevelService.getListByStudent()
          .then(({data}) => {
            _this.items = data;
          });
      },
      onInput(event) {
        this.$emit('input', event);
      }
    },
  }
</script>

<style scoped>

</style>
